import { PageSubtitle } from "@/shared/ui/page-subtitle";
import { PageHeader } from "@/widgets/page-header";
import { fetchBonusProcessingTransactions } from "../model";
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux";
import { selectBonusProcessingTransactionsBonus, selectBonusProcessingTransactionsCurrentPage, selectBonusProcessingTransactionsEndDate, selectBonusProcessingTransactionsFirstLoad, selectBonusProcessingTransactionsWithAccrual } from "../model/selectors";
import { useEffect, useRef } from "react";
import { ProcessingTransactionsTable } from "./processing-transactions-table";
import { TransactionsFilters } from "./transactions-filters";

export const BonusProcessingTransactionsPage = () => {
    const isFirstRender = useRef(true);
    const page = useAppSelector(selectBonusProcessingTransactionsCurrentPage)
    const endDate = useAppSelector(selectBonusProcessingTransactionsEndDate)
    const bonusId = useAppSelector(selectBonusProcessingTransactionsBonus)
    const withAccrual = useAppSelector(selectBonusProcessingTransactionsWithAccrual)
    const bonusTransactionsFirstLoad = useAppSelector(selectBonusProcessingTransactionsFirstLoad)
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (!isFirstRender.current) {
            dispatch(fetchBonusProcessingTransactions())
        }
    }, [page, endDate, bonusId, withAccrual])

    useEffect(() => {
        if (bonusTransactionsFirstLoad) {
            dispatch(fetchBonusProcessingTransactions())
        }
        isFirstRender.current = false
    }, [])

    return (
        <div className="_page_container">
            <PageHeader title="Бонусы" />
            <div className='flexbox'>
                <PageSubtitle variant="acid" title="Транзакции клиентов" />
                <TransactionsFilters />
                <ProcessingTransactionsTable />
            </div>
        </div>
    )
}
